// extracted by mini-css-extract-plugin
export var noSpinners = "_mp-6";
export var percentageInput = "_mp-7";
export var variantColor1 = "_mp-0";
export var variantColor2 = "_mp-1";
export var variantColor3 = "_mp-2";
export var variantColor4 = "_mp-3";
export var variantColor5 = "_mp-4";
export var variantColor6 = "_mp-5";